import styled from "styled-components";

export const Wrapper = styled.div``;

export const Minutes = styled.span``;

export const Seconds = styled.span``;
